import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { t } from 'utils/getLiteral';
import Select from 'components/Select';
import { EntityChip } from 'components/chips';
import Base from './Base';

class SelectMultiple extends PureComponent {
    onRemove = (id) => {
        const idStr = id.toString();
        const { onChange = () => null, options = [], value = [] } = this.props;
        const result = value.filter((v) => idStr !== v.toString());
        onChange(result, options);
    };

    onChange = ([data]) => {
        const { onChange = () => null, value = [], options = [] } = this.props;
        if (!value.includes(data.value)) {
            onChange([...value, data.value], options);
        }
    };

    renderSelected = () => {
        const { value = [], options = [] } = this.props;

        if (!Array.isArray(value)) return null;

        const mappedValues = options.reduce((obj, item) => {
            obj[item.value] = item;
            return obj;
        }, {});

        return value.map((v) => {
            const { isDismissible } = this.props;
            const item = mappedValues[v];
            if (!item) return null;
            return (
                <EntityChip
                    key={item.value}
                    id={Number(item.value)}
                    name={item.label}
                    isDismissible={isDismissible}
                    onClickDismissible={() => this.onRemove(item.value)}
                    isClearable={false}
                />
            );
        });
    };

    renderError = () => {
        const { error } = this.props;

        if (!error || typeof error === 'object') return null;
        return <div className="fm-field-error">{error}</div>;
    };

    render() {
        const {
            label = '',
            labelMode = 'horizontal',
            hidden,
            options = [],
            value = [],
            hint = '',
            mandatory,
            description = '',
            error,
            disabled,
            readOnly,
            ...props
        } = this.props;

        if (hidden) {
            return null;
        }

        const visibleOptions = options.filter((option) => !value.includes(option.value));

        return (
            <div className="fm-field-select">
                <Base
                    label={label}
                    mandatory={mandatory}
                    description={description}
                    labelMode={labelMode}
                >
                    <Select
                        {...props}
                        value={[]}
                        onChange={this.onChange}
                        options={visibleOptions}
                        placeholder={hint || t('label_selectone')}
                        isClearable={false}
                        isDisabled={disabled || readOnly}
                        isMulti
                        hideSelectedOptions
                    />
                    {this.renderError()}
                    <div className="fm-field-container-selected fm-field-multi-selected">
                        {this.renderSelected()}
                    </div>
                </Base>
            </div>
        );
    }
}

SelectMultiple.propTypes = {
    hint: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    onRemove: PropTypes.func,
    onChange: PropTypes.func,
    value: PropTypes.arrayOf(PropTypes.any),
    className: PropTypes.string,
    error: PropTypes.node,
    mandatory: PropTypes.bool,
    readOnly: PropTypes.bool,
    hidden: PropTypes.bool,
    options: PropTypes.arrayOf(PropTypes.object),
    description: PropTypes.string,
    label: PropTypes.string,
    labelMode: PropTypes.string,
    disabled: PropTypes.bool,
};

export default SelectMultiple;
